import React, { useEffect, useState } from "react";
import CIcon from '@coreui/icons-react';
import { cibTelegram } from '@coreui/icons';
import '../style.css';

function VideoPlayer({ videoSrc }) {
    const [playerReady, setPlayerReady] = useState(false);

    useEffect(() => {
        if (videoSrc && window.jwplayer) {
            const playerInstance = window.jwplayer("player").setup({
                controls: true,
                sharing: false,
                autostart: true,
                displaytitle: true,
                displaydescription: true,
                skin: { name: "netflix" },
                logo: {
                    file: "/star.png",
                    link: "https://t.me/star_ccricket"
                },
                playlist: [
                    {
                        sources: [{ file: videoSrc, label: "Auto", default: true }],
                        tracks: [{ file: "https://cdn.jwplayer.com/strips/iYfADWO1-120.vtt", kind: "thumbnails" }]
                    }
                ],
            });

            playerInstance.on("ready", function () {
                setPlayerReady(true);

                const playerContainer = playerInstance.getContainer();
                const buttonContainer = playerContainer.querySelector(".jw-button-container");
                const spacer = buttonContainer.querySelector(".jw-spacer");
                const timeSlider = playerContainer.querySelector(".jw-slider-time");
                if (spacer && timeSlider) {
                    buttonContainer.replaceChild(timeSlider, spacer);
                }

                const rewindContainer = playerContainer.querySelector(".jw-display-icon-rewind");
                if (rewindContainer) {
                    const forwardContainer = rewindContainer.cloneNode(true);
                    const forwardDisplayButton = forwardContainer.querySelector(".jw-icon-rewind");
                    if (forwardDisplayButton) {
                        forwardDisplayButton.style.transform = "scaleX(-1)";
                        forwardDisplayButton.ariaLabel = "Forward 10 Seconds";
                    }

                    const nextContainer = playerContainer.querySelector(".jw-display-icon-next");
                    if (nextContainer && nextContainer.parentNode) {
                        nextContainer.parentNode.insertBefore(forwardContainer, nextContainer);
                        nextContainer.style.display = "none";
                    }

                    const rewindControlBarButton = buttonContainer.querySelector(".jw-icon-rewind");
                    if (rewindControlBarButton) {
                        const forwardControlBarButton = rewindControlBarButton.cloneNode(true);
                        forwardControlBarButton.style.transform = "scaleX(-1)";
                        forwardControlBarButton.ariaLabel = "Forward 10 Seconds";
                        rewindControlBarButton.parentNode.insertBefore(forwardControlBarButton, rewindControlBarButton.nextElementSibling);

                        [forwardDisplayButton, forwardControlBarButton].forEach((button) => {
                            if (button) {
                                button.onclick = () => {
                                    playerInstance.seek(playerInstance.getPosition() + 10);
                                };
                            }
                        });
                    }
                }
            });
        }
    }, [videoSrc]);

    useEffect(() => {
        const preventContext = (e) => e.preventDefault();
        const blockKeys = (e) => {
            if (e.keyCode === 123 || (e.ctrlKey && e.shiftKey && e.keyCode === 73)) {
                e.preventDefault();
            }
        };

        document.addEventListener("contextmenu", preventContext);
        document.addEventListener("keydown", blockKeys);

        return () => {
            document.removeEventListener("contextmenu", preventContext);
            document.removeEventListener("keydown", blockKeys);
        };
    }, []);

    return (
        <div className="w-full max-w-4xl relative">
            <div className="jw-skin-wrapper">
                <div id="player" className="aspect-video bg-black rounded-lg shadow-2xl"></div>
            </div>
            {!playerReady && (
                <div className="absolute inset-0 flex items-center justify-center">
                    <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-yellow-400"></div>
                </div>
            )}

            {/* Telegram CTA */}
            <div className="mt-8 flex flex-col gap-4 text-center">
                <a
                    href="https://telegram.me/star_ccricket"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 rounded-lg transition-colors font-bold"
                >
                    <CIcon icon={cibTelegram} size="lg" className="text-white w-8 h-8" />
                    <span className="text-lg">Join our Telegram Channel</span>
                </a>
                <div className="text-gray-400 text-sm">
                    For match schedules, updates and special features
                </div>
            </div>

            <div className="mt-4 text-center">
                <button
                    onClick={() => window.history.back()}
                    className="px-4 py-2 bg-yellow-500 hover:bg-yellow-600 text-black rounded-md font-bold transition-colors mt-4"
                >
                    Back to Home
                </button>
            </div>
        </div>
    );
}

export default VideoPlayer;